import { render, staticRenderFns } from "./marketCode.vue?vue&type=template&id=a3c25ade&"
import script from "./marketCode.vue?vue&type=script&lang=js&"
export * from "./marketCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports